module.exports = __webpack_public_path__ + "img/farming_54.8463b936.png";